import * as actions from './master/actions'
import * as mutations from './master/mutations'
import * as getters from './master/getters'

const state = {
    visitor_geography_detail: {country: '', timezone: ''},
    country_list: [],
    salutation_list: [],
    screen_width: 0,
    feature_list_port: 0,
    font_sizes: {f13: '13px', f16: '16px', f18: '18px', f20: '20px', f22: '22px', f24: '24px', f28: '28px', f48: '48px', f50: '50px', f54: '54px'},
    timings: {
        sales: {"start": '', "end": ''},
        support: {"start": '', "end": ''}
    },
    props: {
        first_name: '',
        last_name: '',
        email_address: '',
        mobile_number_calling_code: '',
        mobile_number: '',
        brand_name: '',
        production_type: 0,
        garment_type: 0,
        gender_type: 0,
        warning: false,
        warning_message: '',
        form_submitted: false,
        form_submitted_message: ''   
    },
    menu_toggle: false,
    meta: {
        title: 'Easy Tailor App'
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/master.js